import { useCallback, useEffect } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePageBannerGuestMessage, usePageBannerMessage } from 'src/app/pages/psf/share/shared/hooks';

type Result = ModelHookResult<
	{
		message?: string;
		guestMessage?: string;
	},
	{
		trackGuestMessageLinkClick: () => void;
	}
>;

export function usePageBanner(): Result {
	const track = useTracking();
	const message = usePageBannerMessage();
	const guestMessage = usePageBannerGuestMessage();

	useEffect(() => {
		if (guestMessage) {
			void track('post_sign_verify_banner_view');
		}
	}, [guestMessage, track]);

	return {
		data: {
			message,
			guestMessage,
		},
		actions: {
			trackGuestMessageLinkClick: useCallback(() => {
				void track('post_sign_verify_banner_click');
			}, [track]),
		},
	};
}
